import { cn } from "@breakout/ui/utils"
import type { ReactNode } from "react"

interface PageContainerProps {
	children: ReactNode
	className?: string
}

export function PageContainer({ children, className }: PageContainerProps) {
	return (
		<div className={cn("mx-auto box-border w-full max-w-6xl px-4 sm:px-6 lg:px-8", className)}>
			{children}
		</div>
	)
}
